import AsyncStorage from '@react-native-async-storage/async-storage';

const sendSupportRequest = async (
  topic,
  problem,
  description,
  email,
) => {
  try {
    const clientName = await AsyncStorage.getItem('clientName');
    const emailFromStorage = await AsyncStorage.getItem('email');
    const name = await AsyncStorage.getItem('name');
    const apiDomain = await AsyncStorage.getItem('apiDomain') ?? 'api-v2.hereworks.tech';
    const jwtToken = await AsyncStorage.getItem('token');

    // eslint-disable-next-line no-undef
    const requestHeaders: HeadersInit = new Headers();
    requestHeaders.set('clientid', clientName ?? 'hereworks');
    requestHeaders.set('Content-Type', 'application/json');
    requestHeaders.set('jwt', jwtToken ?? '');

    const url = `https://${apiDomain}/button/support-request`;

    const response = await fetch(
      url,
      {
        method: 'POST',
        headers: requestHeaders,
        body: JSON.stringify({
          topic,
          problem: problem ?? '',
          desc: description,
          name: name ?? '',
          email: email || emailFromStorage,
        }),
      },
    );
    const json = await response.json();
    return json;
  } catch (error) {
    return null;
  }
};

export default sendSupportRequest;
